// The older newsletter endpoint: "<project id>-<NN><md5>" for a numbered group,
// "<project id>-<name>-<md5>" for a named one. Strict, so nothing else is rewritten.
const OLDER_NEWSLETTER_ADDRESS =
	/^([A-Za-z0-9]+)-([0-9]{2}[0-9a-f]{32}|[a-z0-9]{2,20}-[0-9a-f]{32})@(.+)$/;

/**
 * A newsletter endpoint in the "nl" layout, the one the backend hands out now
 * (infra mail/filter_mail nl_address): the older address with the project id moved to
 * the end, "nl<NN><md5>.<project id>" for a numbered group and
 * "nl.<name>-<md5>.<project id>" for a named one. The group and the md5 are the same,
 * so the mail filter accepts both; an address already in the "nl" layout, or anything
 * that is not an older newsletter address, comes back unchanged.
 */
export function nlNewsletterAddress(address: string): string {
	if (typeof address !== 'string') return address;

	const older = address.match(OLDER_NEWSLETTER_ADDRESS);
	if (!older) return address;

	const [, projectId, rest, domain] = older;
	return `${rest.includes('-') ? 'nl.' : 'nl'}${rest}.${projectId}@${domain}`;
}
